<template>
  <div class="download-popup">
    <div class="header">
      <div class="header__images">
        <van-image :src="downloadPopupLogoUrl" />
      </div>
      <div class="header__label">
        <span>{{ t('home-index.download.shortcutPrompt') }}</span>
      </div>
    </div>

    <div class="buttons-container">
      <div class="main-button" @click="emit('install')">
        {{ t('home-index.download.desktopShortcut') }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { downloadPopupLogoUrl } from './js/index.js'

const { t } = useI18n()
const emit = defineEmits(['install'])
</script>

<style lang="less" scoped src="./css/index.less"></style>
